import { Button, Flex, Menu, Text } from "@mantine/core";
import { IconChevronDown, type TablerIcon } from "@tabler/icons-react";
import { Children, cloneElement, type ReactElement } from "react";

export function ButtonMenu({
  id,
  label,
  icon,
  tooltip,
  children,
  disabled = false,
}: {
  id: string;
  label: string;
  icon: TablerIcon;
  tooltip: string;
  children?: React.ReactNode;
  disabled?: boolean;
}) {
  const Icon = icon;

  const buttonColor = disabled
    ? "var(--mantine-color-gray-6)"
    : "var(--mantine-color-dark-6)";

  return (
    <Menu
      width={200}
      shadow="lg"
      withArrow
      offset={0}
      position="bottom"
      closeOnItemClick={false}
      disabled={disabled}
      zIndex={100}
    >
      <Menu.Target>
        <Button
          c={buttonColor}
          variant="white"
          px="sm"
          h="100%"
          disabled={disabled}
          opacity={disabled ? 0.6 : 1}
        >
          <Flex direction="column" align="center" justify="center" gap={4}>
            <Flex align="center" gap={2} pl={10}>
              <Icon size={22} stroke={1.2} />
              <IconChevronDown size={10} />
            </Flex>
            <Text fw={400} fz={13}>
              {label}
            </Text>
          </Flex>
        </Button>
      </Menu.Target>
      <Menu.Dropdown p={4} pb={8}>
        <Menu.Label ta="center" tt="uppercase" fw={600} py={10}>
          {tooltip}
        </Menu.Label>
        {Children.map(children, (child) => {
          const element = child as ReactElement<{
            parentId?: string;
            disabled?: boolean;
          }>;
          return cloneElement(element, { parentId: id, disabled: disabled });
        })}
      </Menu.Dropdown>
    </Menu>
  );
}
